const isFormatLiloBag = (value: string | null | undefined): boolean => {
  if (!value) return false; // Handle null, undefined, or empty string
  const liloPattern = /(tkp01-bag|bag)/i; // Check for 'tkp01-bag' or 'bag' (case-insensitive)
  return liloPattern.test(value.trim().toLowerCase());
};

export default isFormatLiloBag;
